import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import chunk from 'lodash-es/chunk';
import { Box, Heading } from '@components/common';
import { MobileContainer } from '@containers/layout';
import SelectorButton from '@components/SelectorButton';
import PropertySelect from '@containers/properties/PropertySelect';

import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import { AppSelectors } from '@redux/AppRedux';

const ButtonWrapper = styled(SelectorButton)`
  width: 164px;
  height: 164px;
`;

function Frequency(props) {
  const {
    selectedFrequency,
    frequencyData,
    setFrequency,
    currentProperty,
    setProperty,
    isPMUser,
    onSubmit
  } = props;

  const totalFrequencies = Object.keys(frequencyData);
  const frequencyGroups = chunk(totalFrequencies, 2);

  return (
    <MobileContainer>
      <Heading px={2} mb={4}>
        How often would you like this service?
      </Heading>

      {!isPMUser && (
        <Box px={2} mb={4}>
          <PropertySelect
            value={currentProperty}
            onChange={pp => {
              setProperty(pp);
            }}
          />
        </Box>
      )}

      {frequencyGroups.map(group => {
        if (!group.length > 0) {
          return null;
        }
        const key = `frequency_group_${group[0]}`;
        return (
          <Box key={key} px={2} display="flex" flexDirection="row">
            {group.map((frequency, index) => {
              const data = frequencyData[frequency];
              const { title, subtitle, icon } = data;
              return (
                <ButtonWrapper
                  key={frequency}
                  selected={frequency === selectedFrequency}
                  title={title}
                  subtitle={subtitle}
                  icon={icon}
                  iconColor="gold"
                  onClick={() => {
                    setFrequency(frequency);
                    onSubmit();
                  }}
                  mr={index === 0 ? 2 : undefined}
                />
              );
            })}
          </Box>
        );
      })}
    </MobileContainer>
  );
}

Frequency.propTypes = {
  selectedFrequency: PropTypes.string,
  currentProperty: PropTypes.object,
  frequencyData: PropTypes.object,
  setFrequency: PropTypes.func,
  setProperty: PropTypes.func,
  isPMUser: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state),
  currentProperty: BookingSelectors.selectCurrentProperty(state),
  frequencyData: AppSelectors.selectFrequencyData(state),
  isPMUser: AuthSelectors.selectIsPMUser(state)
});

const mapDispatchToProps = dispatch => ({
  setFrequency: frequency =>
    dispatch(BookingActions.setBookingFrequency(frequency)),
  setProperty: property => dispatch(BookingActions.setBookingProperty(property))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(Frequency);
